var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.guide_is_show
    ? _c("div", [
        _vm.kikikuru_layer_is_show
          ? _c("div", { staticClass: "map-legend" }, [
              _c("div", [
                _vm._v(
                  "(" +
                    _vm._s(
                      _vm._f("datetime")(
                        _vm.target_times.kikikuru_target_time.basetime
                      )
                    ) +
                    ")"
                )
              ]),
              _c("img", {
                attrs: { src: _vm.kikikuru_guide_url, alt: "*", "uk-svg": "" }
              })
            ])
          : _vm._e(),
        _vm.snowd_layer_is_show
          ? _c("div", { staticClass: "map-legend" }, [
              _c("div", { staticClass: "uk-text-bold" }, [
                _vm._v("解析・予報 / アメダス")
              ]),
              _c("div", [_vm._v("今後6時間の降雪短時間予報")]),
              _c("div", [
                _vm._v(
                  "(" +
                    _vm._s(
                      _vm._f("datetime")(
                        _vm.target_times.snowd_target_time.basetime
                      )
                    ) +
                    ")"
                )
              ]),
              _c("img", {
                attrs: { src: _vm.snow_guide_url, alt: "*", "uk-svg": "" }
              })
            ])
          : _vm._e(),
        _vm.raind_layer_is_show
          ? _c("div", { staticClass: "map-legend" }, [
              _c("div", [_vm._v("今後3時間の降水短時間予報")]),
              _c("div", [
                _vm._v(
                  "(" +
                    _vm._s(
                      _vm._f("datetime")(
                        _vm.target_times.raind_target_time.basetime
                      )
                    ) +
                    ")"
                )
              ]),
              _c("div", [
                _c("img", {
                  attrs: { src: _vm.raind_guide_url, alt: "*", "uk-svg": "" }
                })
              ]),
              _c("div", [
                _c("img", {
                  attrs: { src: _vm.raind_guide_mics, alt: "*", "uk-svg": "" }
                })
              ])
            ])
          : _vm._e(),
        !_vm.kikikuru_layer_is_show &&
        !_vm.snowd_layer_is_show &&
        !_vm.raind_layer_is_show
          ? _c("div", [
              _c(
                "div",
                {
                  staticClass:
                    "uk-position-bottom-right uk-position-small uk-box-shadow-medium map-guide"
                },
                [
                  _vm.guides
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "uk-section-xsmall uk-padding-small uk-border-rounded uk-position-relative",
                          staticStyle: { "background-color": "white" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "uk-text-small uk-margin-remove uk-text-bold"
                            },
                            [_vm._v("ハザードマップ凡例")]
                          ),
                          _vm.hazard_extends_minase_naruse_omonogawa_layer_is_show ||
                          _vm.hazard_extends_minase_naruse_omonogawa_soukihinan_layer_is_show ||
                          _vm.hazard_extends_yokotegawa_layer_is_show ||
                          _vm.hazard_extends_yokotegawa_soukihinan_layer_is_show ||
                          _vm.hazard_extends_uwamizo_layer_is_show ||
                          _vm.hazard_extends_saragawa_layer_is_show ||
                          _vm.hazard_extends_ootogawa_layer_is_show ||
                          _vm.hazard_extends_kashiranashigawa_layer_is_show ||
                          _vm.hazard_extends_budougawa_layer_is_show ||
                          _vm.hazard_extends_iwanomesawa_layer_is_show ||
                          _vm.hazard_extends_kuriyagawa_layer_is_show ||
                          _vm.hazard_extends_kurosawagawa_layer_is_show ||
                          _vm.hazard_extends_matsukawa_layer_is_show ||
                          _vm.hazard_extends_minasegawa_layer_is_show ||
                          _vm.hazard_extends_naraokagawa_layer_is_show ||
                          _vm.hazard_extends_narusegawa_layer_is_show ||
                          _vm.hazard_extends_sakabegawa_layer_is_show ||
                          _vm.hazard_extends_shirakogawa_layer_is_show ||
                          _vm.hazard_extends_sugisawagawa_layer_is_show ||
                          _vm.hazard_extends_ugoootogawa_layer_is_show ||
                          _vm.hazard_extends_yokotegawasannai_layer_is_show ||
                          _vm.hazard_extends_nakanomekawa_layer_is_show ||
                          _vm.hazard_extends_imokawa_layer_is_show
                            ? _c(
                                "div",
                                [
                                  _c("hr", { staticClass: "uk-margin-small" }),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "uk-text-bold uk-text-small"
                                    },
                                    [_vm._v("浸水想定")]
                                  ),
                                  _vm._l(_vm.guides.flood, function(
                                    guide,
                                    index
                                  ) {
                                    return _c(
                                      "div",
                                      { key: "guide_hazard_" + index },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "uk-flex uk-grid-small uk-flex-middle"
                                          },
                                          [
                                            _c("div", [
                                              _c("div", {
                                                style:
                                                  "width: 15px; height: 15px; background-color: " +
                                                  guide.color +
                                                  "!important"
                                              })
                                            ]),
                                            _c("div", [
                                              _vm._v(_vm._s(guide.label))
                                            ])
                                          ]
                                        )
                                      ]
                                    )
                                  }),
                                  _vm.hazard_extends_minase_naruse_omonogawa_soukihinan_layer_is_show ||
                                  _vm.hazard_extends_yokotegawa_soukihinan_layer_is_show
                                    ? _c("div", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "uk-flex uk-grid-small uk-flex-middle"
                                          },
                                          [
                                            _c("div", [
                                              _c("div", {
                                                style:
                                                  "width: 15px; height: 15px; border: dashed 2px red!important; box-sizing: border-box;"
                                              })
                                            ]),
                                            _c("div", [_vm._v("早期避難")])
                                          ]
                                        )
                                      ])
                                    : _vm._e()
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm.ekijyoka_layer_is_show
                            ? _c(
                                "div",
                                [
                                  _c("hr", { staticClass: "uk-margin-small" }),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "uk-text-bold uk-text-small"
                                    },
                                    [_vm._v("液状化危険度")]
                                  ),
                                  _vm._l(_vm.guides.ekijyoka, function(
                                    guide,
                                    index
                                  ) {
                                    return _c(
                                      "div",
                                      { key: "guide_ekijyoka_" + index },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "uk-flex uk-grid-small uk-flex-middle"
                                          },
                                          [
                                            _c("div", [
                                              _c("div", {
                                                style:
                                                  "width: 15px; height: 15px; background-color: " +
                                                  guide.color +
                                                  "!important"
                                              })
                                            ]),
                                            _c("div", [
                                              _vm._v(_vm._s(guide.label))
                                            ])
                                          ]
                                        )
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm.sediment_layers_is_show
                            ? _c(
                                "div",
                                [
                                  _c("hr", { staticClass: "uk-margin-small" }),
                                  _vm._l(_vm.guides.sediment, function(
                                    guide,
                                    index
                                  ) {
                                    return _c(
                                      "div",
                                      { key: "guide_sediment_" + index },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "uk-flex uk-grid-small uk-flex-middle"
                                          },
                                          [
                                            _c("div", [
                                              _c("div", {
                                                style:
                                                  "width: 15px; height: 15px; border: solid 2px " +
                                                  guide.color +
                                                  "!important"
                                              })
                                            ]),
                                            _c("div", [
                                              _vm._v(_vm._s(guide.label))
                                            ])
                                          ]
                                        )
                                      ]
                                    )
                                  }),
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "uk-border-circle uk-flex-center uk-flex-middle uk-position-absolute",
                                      staticStyle: {
                                        width: "18px",
                                        height: "18px",
                                        "background-color": "black!important",
                                        color: "white!important",
                                        display: "block",
                                        border: "solid 1px #2b2b2b",
                                        left: "-5px",
                                        top: "-5px",
                                        padding: "0",
                                        "line-height": "1",
                                        "text-align": "center",
                                        "font-size": "15px"
                                      },
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.handleToggleGuide.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("×")]
                                  )
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm.tameike_layers_is_show
                            ? _c("div", [
                                _c("hr", { staticClass: "uk-margin-small" }),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "uk-flex uk-grid-small uk-flex-middle"
                                  },
                                  [
                                    _c("div", [
                                      _c("div", {
                                        style:
                                          "width: 15px; height: 15px; background: rgba(0, 0, 255, 0.3); border: solid 2px blue; opacity: 0.8;"
                                      })
                                    ]),
                                    _c("div", [_vm._v("ため池浸水想定区域")])
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "uk-flex uk-grid-small uk-flex-middle"
                                  },
                                  [
                                    _c("div", [
                                      _c("div", {
                                        style:
                                          "width: 15px; height: 15px; background: rgba(0, 0, 255, 0.3); border: solid 2px blue; opacity: 0.8; border-radius: 15px;"
                                      })
                                    ]),
                                    _c("div", [
                                      _vm._v("ため池決壊想定ポイント")
                                    ])
                                  ]
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    : _vm._e()
                ]
              )
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }